import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class FileAnalystUserType {
  public readonly key = 'FileAnalystUserType';
  public readonly enrollTrackRole = EnrollTrackRole.FileAnalyst;
}
